var map = {
	"./es/announcements/list.json": [
		388,
		3
	],
	"./es/classes-book/edit.json": [
		389,
		4
	],
	"./es/classes-book/list.json": [
		390,
		5
	],
	"./es/common.json": [
		391,
		6
	],
	"./es/courses/details.json": [
		392,
		7
	],
	"./es/courses/list.json": [
		393,
		8
	],
	"./es/grade-replacement-petitions/list.json": [
		394,
		9
	],
	"./es/layouts.authorized.json": [
		395,
		10
	],
	"./es/learning-result/associate.json": [
		396,
		11
	],
	"./es/learning-result/list.json": [
		397,
		12
	],
	"./es/student-file/academic-history.json": [
		398,
		13
	],
	"./es/student-file/educational-background.json": [
		399,
		14
	],
	"./es/student-file/list.json": [
		400,
		15
	],
	"./es/student-file/personal-information.json": [
		401,
		16
	],
	"./es/student-file/petition.json": [
		402,
		17
	],
	"./es/student-file/tabs.json": [
		403,
		18
	],
	"./es/teacher-attendance/list.json": [
		404,
		19
	],
	"./es/teacher-schedule/list.json": [
		405,
		20
	],
	"./es/terms.json": [
		406,
		21
	],
	"./es/translation.json": [
		407,
		22
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 383;
module.exports = webpackAsyncContext;